import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Protect from "@/pages/Protect";
import Lodge from "../pages/Lodge";
import NewTrip from "../pages/NewTrip";
import TripBuilder from "../pages/TripBuilder";
import Booking from "../pages/Booking";
import ActiveTrips from "../pages/ActiveTrips";
import Explore from "../pages/Explore";
import Account from "../pages/Account";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import Callback from "../pages/Callback";
import Logout from "../pages/Logout";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/landingPage";
import AboutPage from "../pages/aboutPage";
import ContactPage from "../pages/Contact";
import USContactPage from "../pages/USContact";
import TermsOfServicePage from "../pages/TermsOfService";
import PrivacyPolicyPage from "../pages/PrivacyPolicy";
import CopyrightRemovalPage from "../pages/CopyrightRemoval";

const RoutesConfig: React.FC = () => {
  return (
    <Routes>
      {/* Public routes that are always accessible */}
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/contact/us" element={<USContactPage />} />
      <Route path="/terms" element={<TermsOfServicePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/copyright-removal" element={<CopyrightRemovalPage />} />
      <Route path="/protect" element={<Protect />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/auth/callback" element={<Callback />} />
        <Route path="/lodge" element={<Lodge />} />
        <Route path="/trip-builder/:id" element={<TripBuilder />} />
        <Route path="/account/:id?" element={<Account />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/active-trips" element={<ActiveTrips />} />
        <Route path="/new-trip" element={<NewTrip />} />
        <Route path="/booking/:tripId/:type/:itemId" element={<Booking />} />
      </Route>

      {/* 404 route - must be last */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default RoutesConfig;
